var React = require('react');

function Hilo (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"62.2 50.8 62.2 91.4 21 91.4 21 50.8 0 50.8 0 152.9 21 152.9 21 110.9 62.2 110.9 62.2 152.9 83.2 152.9 83.2 50.8 62.2 50.8","key":0}),React.createElement("path",{"d":"M111.3,25.4A12.59,12.59,0,0,0,124,12.7a12.7,12.7,0,0,0-25.4,0A12.53,12.53,0,0,0,111.3,25.4Z","key":1}),React.createElement("rect",{"x":"100.8","y":"76.3","width":"21","height":"76.6","key":2}),React.createElement("rect",{"x":"139.3","y":"50.8","width":"21","height":"102.1","key":3}),React.createElement("path",{"d":"M211.7,74.3a39.61,39.61,0,0,0-39.9,40.1c0,22.5,17.5,40.1,39.9,40.1s39.9-17.6,39.9-40.1S234.1,74.3,211.7,74.3Zm0,61.1c-10.7,0-19.2-9.2-19.2-21s8.4-21,19.2-21,19.2,9.2,19.2,21S222.5,135.4,211.7,135.4Z","key":4})]);
}

Hilo.defaultProps = {"viewBox":"0 0 251.6 154.5"};

module.exports = Hilo;

Hilo.default = Hilo;
